let cookies;
export function readCookies() {
    cookies = Object.fromEntries(document.cookie.split('; ').map(v => v.split('=').map(decodeURIComponent)));
}
export function getCookieValue(name) {
    if (!cookies)
        readCookies();
    return cookies[name];
}
export function setCookieValue(name, value, options) {
    const serializedOptions = [
        (options === null || options === void 0 ? void 0 : options.path) ? `Path=${options.path}` : undefined,
        (options === null || options === void 0 ? void 0 : options.domain) ? `Domain=${options.domain}` : undefined,
        typeof (options === null || options === void 0 ? void 0 : options.maxAge) === 'number' ? `Max-Age=${options.maxAge}` : undefined,
        (options === null || options === void 0 ? void 0 : options.secure) ? 'Secure' : undefined,
        (options === null || options === void 0 ? void 0 : options.sameSite) ? `SameSite=${options.sameSite}` : undefined
    ].filter(Boolean);
    document.cookie = `${name}=${value}${serializedOptions.length ? `; ${serializedOptions.join('; ')}` : ''}`;
    if (!cookies) {
        readCookies();
        return;
    }
    cookies[name] = value;
}
//# sourceMappingURL=Cookie.js.map